import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { BotsCreators } from '../../../../store/actions/bots';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import '../Analyze.scss';
import OverviewCard from '../../../../components/Builder/Overview/OverviewCard';
import iconUsers from '../../../../assets/images/icon_usuarios.svg';
import iconMessagesReceived from '../../../../assets/images/icon_mensagem_recebida.svg';
import iconMessagesSent from '../../../../assets/images/icon_mensagem_enviada.svg';
import FilterData from '../../../../components/FilterAnalyze/FilterData/FilterData';

/**
 * Component for show the general state of current bot
 *
 * @param {*} props
 * @returns
 */
const BotGeneralStatus = (props) => {
  const { filter, match, filterDashboard, i18n, dashboardFilter, timezone } = props;
  const { botid } = match.params;

  /**
   * Called when the filter data change for reloading page data
   */
  useEffect(() => {
    filterDashboard({
      botid: botid,
      start: filter.startDate,
      end: filter.endDate,
      busc: false,
      timezone: timezone.fuso
    });
  }, [filter]);

  /**
   * Call back for the filter button on the FilterData component
   */
  const onClickFilter = async () => {
    await filterDashboard({
      botid: botid,
      start: filter.startDate,
      end: filter.endDate,
      busc: false,
      timezone: timezone.fuso
    });
  };

  return (
    <div className="container-all-history">
      <FilterData onClickFilter={onClickFilter} />
      <div className="col-md-12 conteudo-analise">
        <OverviewCard
          icon={iconUsers}
          label={i18n.t('Sessões')}
          count={dashboardFilter.sessions || 0}
          countColor="color-orange"
        />
        <OverviewCard
          icon={iconMessagesReceived}
          label={i18n.t('Mensagens Recebidas')}
          count={dashboardFilter.userMessages || 0}
          countColor="color-red"
        />
        <OverviewCard
          icon={iconMessagesSent}
          label={i18n.t('Mensagens Enviadas')}
          count={dashboardFilter.botMessages || 0}
          countColor="color-green"
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  dashboardFilter: state.bots.dashboardFilter,
  filter: state.filter,
  timezone: state.bots.bot.settings.timezone
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...BotsCreators }, dispatch);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(BotGeneralStatus))
);
